import { THANK_YOU_MESSAGES_DYNAMIC_EVENT_NAME_PLACEHOLDER, THANK_YOU_MESSAGES_DYNAMIC_GUEST_EMAIL_PLACEHOLDER, THANK_YOU_MESSAGES_DYNAMIC_GUEST_NAME_PLACEHOLDER, } from '../constants/event';
export const getDynamicThankYouMessage = ({ title = '', subtitle = '' }, { name = '', email = '', eventName = '' }) => {
    const pairs = [
        { placeholder: THANK_YOU_MESSAGES_DYNAMIC_GUEST_NAME_PLACEHOLDER, value: name },
        { placeholder: THANK_YOU_MESSAGES_DYNAMIC_GUEST_EMAIL_PLACEHOLDER, value: email },
        { placeholder: THANK_YOU_MESSAGES_DYNAMIC_EVENT_NAME_PLACEHOLDER, value: eventName },
    ];
    let newTitle = title;
    let newSubtitle = subtitle;
    pairs.forEach(({ placeholder, value }) => {
        newTitle = newTitle.replaceAll(placeholder, value);
        newSubtitle = newSubtitle.replaceAll(placeholder, value);
    });
    return {
        title: newTitle,
        subtitle: newSubtitle,
    };
};
